import React, { useState, useEffect } from "react";
import "./AdminProcess.scss";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
// import "bootstrap-icons/font/bootstrap-icons.css";

const AdminProcess = () => {
  const tokena = localStorage.getItem("raer_token");
  const userId = localStorage.getItem("raer_id");
  console.log("hello from admin process");

  const raerAcess = localStorage.getItem("raerAcess");
  useEffect(() => {
    console.log(raerAcess);
    if (raerAcess !== "1" || !tokena) {
      navigate("/login");
      return;
    }
  });

  const [value, setValue] = useState(0);
  const navigate = useNavigate();
  const acceptHandler = () => setValue(1);
  const backHandler = () => setValue(0);

  const [formData, setFormData] = useState({
    length: 0,
    breadth: 0,
    height: 0,
    weight: 0,
  });

  const [order, setOrder] = useState([]);

  const { orderId } = useParams();

  const handleInputChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };

  const cancelShipment = async () => {
    try {
      const { data } = await axios.post(
        process.env.REACT_APP_BASE_URL + "api/ship/cancelOrderFromAdmin",
        {
          orderId: orderId,
        }
      );
      if (data.success) {
        navigate("/dashboard", { state: { page: "adminProcess" } });
        toast.success("Amount Refunded successfully", {
          position: "bottom-right",
          autoClose: 8000,
          pauseOnHover: true,
          draggable: true,
          theme: "dark",
        });
        navigate("/dashboard");
      }
    } catch (error) {
      // toast.error(`Amount Refunded Successfully`, {
      //   position: "bottom-right",
      //   autoClose: 8000,
      //   pauseOnHover: true,
      //   draggable: true,
      //   theme: "dark",
      // });
    }
  };

  const getOrderDetails = () => {
    const config = {
      url: process.env.REACT_APP_BASE_URL + `api/getOrderById/${orderId}`,
      method: "get",
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");

        if (response?.data?.status == true) {
          setOrder(response?.data?.data);
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  const handleOrderConfirm = () => {
    const config = {
      url: process.env.REACT_APP_BASE_URL + `api/ship/approveRequest`,
      method: "post",
      data: {
        orderId: orderId,
        length: formData.length,
        breadth: formData.breadth,
        height: formData.height,
        weight: formData.weight,
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");

        if (response?.data?.status == true) {
          navigate("/dashboard", { state: { page: "adminProcess" } });
          toast.success("Order Accepted", {
            position: "bottom-right",
            autoClose: 4000,
            pauseOnHover: true,
            draggable: true,
            theme: "light",
          });
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  useEffect(() => {
    getOrderDetails();
  }, []);

  return (
    <div>
      <div className="AP-main">
        <div className="AP-outer">
          <i
            class="bi bi-arrow-left-circle"
            onClick={() => {
              navigate("/dashboard", { state: { page: "adminProcess" } });
              window.scrollTo(0, 0);
            }}
          ></i>
          <div className="AP-inner">
            <div className="top row">
              <div className="top-part-1 col-6">
                <h5>Buyer Information</h5>
                <div>
                  <p>
                    <span>Name:</span> {order?.billing_details?.fullName}
                  </p>
                  <p>
                    <span>Email:</span>
                    {order?.billing_details?.email}
                  </p>
                </div>
                <p>
                  <span>Phone:</span> {order?.billing_details?.phone}
                </p>
              </div>
              <div className="top-part-2 col-6">
                <h5>Billing To</h5>
                <p>
                  <span>address: </span> {order?.billing_details?.address}
                </p>
                <p>
                  <span>city:</span> {order?.billing_details?.city}
                </p>
                <p>
                  <span>landmark:</span> {order?.billing_details?.landmark}
                </p>
                <p>
                  <span>state:</span> {order?.billing_details?.state}
                </p>
              </div>
            </div>
            <div className="mid">
              <div className="mid-outer">
                <div className="mid-inner">
                  <div className="mid-head row">
                    <div className="part-head col-1">
                      <p>Serial No. </p>
                    </div>
                    <div className="part-head col-2">
                      <p>Product Name </p>
                    </div>
                    <div className="part-head col-2">
                      <p>Size </p>
                    </div>
                    <div className="part-head col-1">
                      <p>Unit </p>
                    </div>
                    <div className="part-head col-1">
                      <p>Price (INR)</p>
                    </div>
                    <div className="part-head col-2">
                      <p>Total Amount</p>
                    </div>
                    <div className="part-head col-2">
                      <p>SKU</p>
                    </div>
                  </div>
                  <div className="mid-body">
                    <div className="mid-body-inner-1 ">
                      {order?.products?.map((product, index) => {
                        return (
                          <div className="mid-body-inner-1 row">
                            <div className="part-body col-1">
                              <p>{index + 1}</p>
                            </div>
                            <div className="part-body col-2">
                              <p>{product?.productId?.productName} </p>
                            </div>
                            <div className="part-body col-2">
                              <p>{product?.size} </p>
                            </div>
                            <div className="part-body col-1">
                              <p>{product?.count}</p>
                            </div>
                            <div className="part-body col-1">
                              <p>{product?.productId?.price} </p>
                            </div>
                            <div className="part-body col-2">
                              <p>{product?.price * product?.count}</p>
                            </div>
                            <div className="part-body col-2">
                              <p>{product?.sku} </p>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bottom">
              <div className="bottom-outer">
                <div className="bottom-inner">
                  <div className="head">
                    <h5>Shipping From:</h5>
                  </div>
                  <div className="body">
                    <p>
                      381, M.G Road, Gorakund, Indore, Madhya Pradesh, 452001.
                    </p>
                    <p>
                      <span>Phone: </span>+91 9981914176
                    </p>
                    <p>
                      <span>Email: </span>Raerofficialclothing@gmail.com
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="button-bottom">
              {value == 1 && (
                <div className="table-for-input">
                  <hr />
                  <h5 className="mt-2">
                    Please enter below details to process shipment
                  </h5>
                  <div className="input-table">
                    <div className="accept">
                      <div className="head">
                        <h3>Fill the form</h3>
                      </div>
                      <div className="accept-outer">
                        <label>
                          Weight <p> (in kg)</p>
                        </label>
                        <input
                          type="tel"
                          name="weight"
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="accept-outer">
                        <label>
                          Height <p> (in cm)</p>
                        </label>
                        <input
                          type="tel"
                          name="height"
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="accept-outer">
                        <label>
                          Length <p> (in cm)</p>
                        </label>
                        <input
                          type="tel"
                          name="length"
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="accept-outer">
                        <label>
                          Breadth <p> (in cm)</p>
                        </label>
                        <input
                          type="tel"
                          name="breadth"
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="shipment-buttons">
                        <button
                          className="confirm-button btn btn-primary"
                          onClick={handleOrderConfirm}
                        >
                          Confirm Shipment
                        </button>
                        <button
                          onClick={backHandler}
                          className="back-button btn btn-secondary"
                          style={{ marginLeft: "10px" }}
                        >
                          Back
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div>
              {order?.orderStatus === "REJECTED" ? (
                <div className="accept-reject-button-rejection">
                  <span>
                    The order was Rejected , and Refund was Initiated{" "}
                  </span>
                </div>
              ) : (
                <div>
                  {value == 0 && (
                    <div className="accept-reject-button">
                      {order?.orderStatus === "COMPLETED" ? (
                        <div className="accept-reject-button-rejection">
                          <span>
                            The order is completed , and Pickup is scheduled
                          </span>
                        </div>
                      ) : (
                        <div>
                          {" "}
                          <button
                            type="button"
                            class="btn btn-primary accept-button m-2"
                            onClick={acceptHandler}
                          >
                            Accept
                          </button>
                          <button
                            type="button"
                            class="btn btn-secondary reject-button m-2"
                            onClick={cancelShipment}
                          >
                            Reject
                          </button>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default AdminProcess;
